import { createShapePropsMigrationSequence } from "../records/TLShape.mjs";
const groupShapeProps = {};
const groupShapeMigrations = createShapePropsMigrationSequence({ sequence: [] });
export {
  groupShapeMigrations,
  groupShapeProps
};
//# sourceMappingURL=TLGroupShape.mjs.map
